export default "__VITE_ASSET__enb7Z1wl__"